import { useEffect } from "react";
import Pricing from "@/components/sections/Pricing";

export default function PricingPage() {
  useEffect(() => { document.title = "Pricing — Warranty_Vault pro"; }, []);
  return (
    <main className="pt-16" data-testid="pricing-page">
      <Pricing />
    </main>
  );
}
